import React, { ReactNode } from 'react';
import { Card, CardTitle } from '../../../Card';

interface PropTypes {
  title: string | ReactNode;
  status?: ReactNode;
  children: ReactNode;
  customStyles?: React.CSSProperties;
  className?: string;
  gap?: string;
}

export const REQUISITION_CARD_MIN_HEIGHT = '459px';

export default function RequisitionCard(props: PropTypes) {
  return (
    <Card
      style={props.customStyles ?? { minHeight: REQUISITION_CARD_MIN_HEIGHT }}
      className={props.className}
    >
      <div className={`d-flex flex-column gap-${props.gap ?? '3'} h-100`}>
        <div className='d-flex fs-3 fw-semibold'>
          <CardTitle>{props.title}</CardTitle>
          <div className={'ms-auto'}>{props.status}</div>
        </div>
        {props.children}
      </div>
    </Card>
  );
}
